import { Route, Routes } from "react-router-dom";
import Userlayout from "../layout/Userlayout";


import NotFoundPage from "../pages/NotFoundPage";

import { PrivateRoute } from "./PrivateRoutes";
import HUmanResourceDashboard from "../pages/human-resource/HumanResourceDashboard";
import EmployeeDetailsPage from "../pages/human-resource/EmployeeDetailsPage";
import EmployeeCreatePage from "../pages/human-resource/EmployeeCreatePage";
import DepartmentListPage from "../pages/human-resource/DepartmentListPage";
import DepartmentDetailsPage from "../pages/human-resource/DepartmentDetailsPage";
import DesignationListPage from "../pages/human-resource/DesignationListPage";
import DesignationDetailsPage from "../pages/human-resource/DesignationDetailsPage";
import JobLocationListPage from "../pages/human-resource/JobLocationListPage";
import JobLocationDetailsPage from "../pages/human-resource/JobLocationDetailsPage";
import EmployeeTypeListPage from "../pages/human-resource/EmployeeTypeListPage";
import EmployeeTypeDetailsPage from "../pages/human-resource/EmployeeTypeDetailsPage";
import SubDepartmentListPage from "../pages/human-resource/SubDepartmentListPage";
import SubDepartmentDetailsPage from "../pages/human-resource/SubDepartmentDetailsPage";
import EmployeeCategoryListPage from "../pages/human-resource/EmployeeCategoryListPage";
import EmployeeCategoryDetailsPage from "../pages/human-resource/EmployeeCategoryDetailsPage";


function HumanResourceRoutes() {
  return (
    <>
      <Userlayout>
        <Routes>
          {/* <Route  path="customers"  element={ 
            <PrivateRoute> <CustomersPage />  </PrivateRoute> }
          ></Route>

          <Route exact path="/customers/customer-details/:customer_id"
            element={  <PrivateRoute> <CustomerDetailsPage />  </PrivateRoute>
            }
          ></Route>

          <Route
            path="/customers/add_customer"
            element={
              <PrivateRoute>
                {" "}
                <AddCustomerPage />{" "}
              </PrivateRoute>
            }
          ></Route> */}

          <Route
            exact
            path="/dashboard"
            element={
              <PrivateRoute>
                {" "}
                <HUmanResourceDashboard />{" "}
              </PrivateRoute>
            }
          ></Route>

                    <Route
                        exact
                        path="/employees/new"
                        element={
                            <PrivateRoute>
                                <EmployeeCreatePage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/employees/:id/edit"
                        element={
                            <PrivateRoute>
                                <EmployeeCreatePage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/employees/:id"
                        element={
                            <PrivateRoute>
                                <EmployeeDetailsPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/departments"
                        element={
                            <PrivateRoute>
                                <DepartmentListPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/departments/:id"
                        element={
                            <PrivateRoute>
                                <DepartmentDetailsPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/department-setup"
                        element={
                            <PrivateRoute>
                                <DepartmentListPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/department-setup/:id"
                        element={
                            <PrivateRoute>
                                <DepartmentDetailsPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/department-setup/details/:id"
                        element={
                            <PrivateRoute>
                                <DepartmentDetailsPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/designation-setup"
                        element={
                            <PrivateRoute>
                                <DesignationListPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/designation-setup/:id"
                        element={
                            <PrivateRoute>
                                <DesignationDetailsPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/job-locations"
                        element={
                            <PrivateRoute>
                                <JobLocationListPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/job-locations/:id"
                        element={
                            <PrivateRoute>
                                <JobLocationDetailsPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/job-location-setup"
                        element={
                            <PrivateRoute>
                                <JobLocationListPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/job-location-setup/:id"
                        element={
                            <PrivateRoute>
                                <JobLocationDetailsPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/employee-type"
                        element={
                            <PrivateRoute>
                                <EmployeeTypeListPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/employee-type/:id"
                        element={
                            <PrivateRoute>
                                <EmployeeTypeDetailsPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/employee-type-setup"
                        element={
                            <PrivateRoute>
                                <EmployeeTypeListPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/employee-type-setup/:id"
                        element={
                            <PrivateRoute>
                                <EmployeeTypeDetailsPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/sub-department-setup"
                        element={
                            <PrivateRoute>
                                <SubDepartmentListPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/sub-department-setup/:id"
                        element={
                            <PrivateRoute>
                                <SubDepartmentDetailsPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/employee-category"
                        element={
                            <PrivateRoute>
                                <EmployeeCategoryListPage />
                            </PrivateRoute>
                        }
                    ></Route>

                    <Route
                        exact
                        path="/employee-category/:id"
                        element={
                            <PrivateRoute>
                                <EmployeeCategoryDetailsPage />
                            </PrivateRoute>
                        }
                    ></Route>

          <Route path="/*" element={<NotFoundPage />}></Route>
        </Routes>
      </Userlayout>
    </>
  );
}

export default HumanResourceRoutes;
